<template>
  <div>
    <div>
      <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
      @click="add">
        新增
      </el-button>
    </div>
    <div>
      <el-table
          :data="tableData"
          style="width: 100%;">
        <el-table-column
            prop="id"
            align="center"
            label="id"
            width="260px">
        </el-table-column>
        <el-table-column
            prop="unitName"
            align="center"
            label="单位名称"
            width="360px">
        </el-table-column>
<!--        <el-table-column-->
<!--            prop="services"-->
<!--            align="center"-->
<!--            label="服务领域"-->
<!--            width="180px">-->
<!--        </el-table-column>-->
        <el-table-column
            prop="type"
            align="center"
            label="所属板块"
            width="180px">
          <template slot-scope="{row}">
            <span v-for="item in unitType" :key="item.value" v-show="item.value==row.type">
              {{item.label}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="webUrl"
            align="center"
            label="官网地址"
            width="180px">
        </el-table-column>
        <el-table-column
            prop="showFlag"
            align="center"
            label="是否展示"
            width="180px">
          <template slot-scope="{row}">
            {{row.showFlag==1?'是':'否'}}
          </template>
        </el-table-column>
        <el-table-column
            prop="sort"
            align="center"
            label="排序等级"
            width="180px"
        >
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            width="240px"
            class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
            >修改</el-button>
            <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleDel(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          style="text-align: center"
          layout="prev, pager, next"
          :total="total"
          :current-page="queryParams.pageNum"
          :page-size="queryParams.pageSize"
          @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="open" width="1000px">
      <el-form ref="form" :model="unit" label-width="110px">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="username" label="公司名称：">
            <el-input v-model="unit.unitName" type="text" style="width: 300px">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="type" label="所属板块：">
            <el-select
                v-model="unit.type" style="width: 300px">
              <el-option
                  v-for="dict in unitType"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="webUrl" label="官网地址：">
              <el-input v-model="unit.webUrl" type="text" style="width: 300px">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="showFlag" label="是否展示：">
              <el-switch
                  v-model="unit.showFlag"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="sort" label="排序等级：">
            <el-input v-model="unit.sort" type="number" style="width: 300px">
            </el-input>
          </el-form-item></el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-form-item prop="services" label="服务领域：" >
<!--          <wang-eidtor ref="editor" :value="unit.services"></wang-eidtor>-->
          <el-input v-model="unit.services" type="textarea" rows="2" >
          </el-input>
        </el-form-item>
        <el-form-item prop="相关图片：">
          <el-upload
              :action="fileUrl"
              :headers="uploadHeaders"
              :file-list="fileList"
              :on-success="handleError"
              list-type="picture-card"
              :on-remove="handleRemove"
>
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" >提 交</el-button>
        <el-button @click="cancel">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {Message} from "element-ui";
import {addUnit, delUnit, getUnitList, updataUnit} from "@/api/admin";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  data(){
    return {
      fileList:[],
      uploadHeaders: {
        Authorization: sessionStorage.getItem('token')// 假设token存储在Vuex中
      },
      fileUrl: process.env.VUE_APP_BASE_API+ "/file/upload",
      dialogImageUrl: undefined,
      dialogVisible: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      total:0,
      tableData:undefined,
      open:false,
      title:undefined,
      unitType:[
        {value:0,
        label:'物流贸易'},
        {value:1,
          label:'数字经济'},
        {value:2,
          label:'城市发展'},
        {value:3,
          label:'绿色能源'},
        {value:4,
          label:'文教旅游'},
        {value:5,
          label:'金融资管'}
      ],
      unit:{
        id: undefined,
        unitName: undefined,
        services: undefined,
        logo: undefined,
        type: undefined,
        webUrl: undefined,
        showFlag: true,
        sort: undefined,
        filesUrl:[],
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    handleError(res,file){
      if(res.code===403){
        Message.error('登录过期，请重新登录')
        setTimeout(() => {
          location.href = '/admin/login';
        },10000)
      }else if(res.code==200){
        this.unit.filesUrl.push({name: file.name, url: res.data,uid:file.uid});
      }
    },

    handleRemove(file) {
      let index=this.unit.filesUrl.findIndex(obj=>obj.uid=file.uid)
      this.unit.filesUrl.splice(index,1)
    },
    handleDel(row){
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
       this.delData(row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      this.getList()
    },
    delData(id){
      delUnit([id]).then(()=>{
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.getList()
      })
    },
    handleUpdate(row){
      this.open=true
      this.title='修改成员单位'
      const data=JSON.parse(JSON.stringify(row))

      this.unit=data
      if (row.filesUrl){
        this.fileList=JSON.parse(JSON.stringify(data.filesUrl))
      }else {
        this.unit.filesUrl=[]
        this.fileList=[]
      }

    },
    handleCurrentChange(pageNum){
      this.queryParams.pageNum=pageNum
      this.getList()
    },
    getList(){
      getUnitList(this.queryParams).then(async res=>{
        const data=await  res.data
          this.tableData= data.content
          this.total=data.totalElements
      })
    },
    add(){
      this.unit={
        id: undefined,
        unitName: undefined,
        services: undefined,
        logo: undefined,
        type: undefined,
        webUrl: undefined,
        showFlag: true,
        sort: undefined,
        filesUrl:[],
      }
      this.fileList=[]
      this.open=true
      this.title="新增成员单位"
    },
    submitForm(){
      // this.unit.services=this.$refs.editor.html
      if(this.title=='新增成员单位'){
        addUnit(this.unit).then((res)=>{
          if(res.code==200){
            Message.success("新增成功")
            this.open=false
            this.getList()
          }else Message.error(res.msg)
        })
      }else {
        updataUnit(this.unit).then((res)=>{
          if(res.code==200){
            Message.success("修改成功")
            this.open=false
            this.getList()
          }else {
            Message.error(res.msg)
          }
        })

      }

    },
    cancel(){
      this.open=false
    }
  }
}
</script>

<style scoped>

</style>
